import React from "react";
import { useNavigate } from "react-router-dom";
import Game from "./Game";
import Lobby from "./Lobby";
import ResultsPage from "./ResultsPage";
import { useOrchestrator } from "./contexts/OrchestratorContext";
import "./MultiPlayerContainer.css";

const GameScreen: React.FC = () => {
  const navigate = useNavigate();
  const { orchestrator, viewState } = useOrchestrator();
  const runtimeHandle = orchestrator?.getHandle() ?? null;
  const gameController = orchestrator?.getController() ?? null;
  const gameState = viewState.rawGameState;

  if (!orchestrator || !runtimeHandle || !gameController) {
    return (
      <div className="multiplayer-page-container">
        <div className="multiplayer-page-loading">
          <div className="loading-spinner" />
          <p>Waiting for game runtime…</p>
          <button
            className="secondary-button"
            style={{ marginTop: "16px" }}
            onClick={() => navigate("/multi-player")}
          >
            Back to Multiplayer Menu
          </button>
        </div>
      </div>
    );
  }

  if (!gameState) {
    return (
      <div className="multiplayer-page-container">
        <div className="multiplayer-page-loading">
          <div className="loading-spinner" />
          <p>Preparing game…</p>
        </div>
      </div>
    );
  }

  const countdownNumber = viewState.countdownNumber;
  const showLobby = viewState.overlay.type === "lobby";
  const showCountdown = viewState.overlay.type === "countdown";
  const showResults = viewState.overlay.type === "results";
  const showLoadingOverlay = viewState.overlay.type === "loading";

  return (
    <div className="multiplayer-page-container">
      <Game
        runtimeHandle={runtimeHandle}
        gameController={gameController}
        gameState={gameState}
      />
      {showLoadingOverlay && (
        <div className="lobby-overlay">
          <div className="multiplayer-page-loading">
            <div className="loading-spinner" />
            <p>Preparing runtime…</p>
          </div>
        </div>
      )}
      {showLobby && (
        <div className="lobby-overlay">
          <Lobby gameState={gameState} gameController={gameController} />
        </div>
      )}
      {showCountdown && countdownNumber !== null && (
        <div className="countdown-overlay">
          <div className="countdown-number">{countdownNumber}</div>
        </div>
      )}
      {showResults && (
        <div className="results-overlay">
          <ResultsPage />
        </div>
      )}
    </div>
  );
};

export default GameScreen;

